import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=22d8d03c&scoped=true&"
import script from "./CartModal.vue?vue&type=script&lang=js&"
export * from "./CartModal.vue?vue&type=script&lang=js&"
import style0 from "./CartModal.vue?vue&type=style&index=0&id=22d8d03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8d03c",
  null
  
)

export default component.exports